export const iconFontAwesomeMoneyCommentDollar = (
	<i className="fa-solid fa-comment-dollar"></i>
);
